// Sibling imports
const requireBridge = require('./shim')

function showAddUrlModal() {
  const AddUrlModal = require('client/components/add-url-modal')
  return AddUrlModal.promise()
  .then(url => {
    if (url) {
      return showMixSelectModal({ url })
    }
  })
}

function showArticleActionsModal(options) {
  const ArticleActionsModal = require('client/components/article-actions-modal')
  return ArticleActionsModal.confirmArticleAction(options)
}

function showArticleShareModal(options) {
  const ArticleShareModal = require('client/components/article-share-modal')
  return ArticleShareModal.promise(options)
}

function showAlertModal(options) {
  const ConfirmModal = require('client/components/confirm')
  return ConfirmModal.alert(options)
}

function showConfirmModal(options) {
  const ConfirmModal = require('client/components/confirm')
  return ConfirmModal.confirm(options)
}

function showMixEditModal(options) {
  const MixEditModal = require('client/components/mix-edit-modal')
  const {
    collectionDeleted,
    collectionEdited
  } = require('client-v2/common/models/collection/actions')
  return MixEditModal.promise(options)
  .then(result => {
    if (result.deleted) {
      app.store.dispatch(collectionDeleted(result.id))
    } else {
      app.store.dispatch(collectionEdited(result))
    }
  })
}

function showMixSelectModal(options) {
  const MixSelectModal = require('client/components/mix-select-modal')
  const { articleMixesUpdated } = require('client-v2/common/models/article/actions')
  return MixSelectModal.promise(Object.assign({
    changeCallback: ({ urlId, mixIds }) => {
      app.store.dispatch(articleMixesUpdated(urlId, mixIds))
    }
  }, options))
}

function showMixShareModal(options) {
  const MixShareModal = require('client/components/mix-share-modal')
  return MixShareModal.promise(options)
}

function showUserActionsModal(options) {
  const UserActionsModal = require('client/components/user-actions-modal')
  return UserActionsModal.confirmUserAction(options)
}

function showUserShareModal(options) {
  const UserShareModal = require('client/components/user-share-modal')
  return UserShareModal.promise(options)
}

module.exports = {
  showAddUrlModal: requireBridge(showAddUrlModal),
  showAlertModal: requireBridge(showAlertModal),
  showArticleActionsModal: requireBridge(showArticleActionsModal),
  showArticleShareModal: requireBridge(showArticleShareModal),
  showConfirmModal: requireBridge(showConfirmModal),
  showMixEditModal: requireBridge(showMixEditModal),
  showMixSelectModal: requireBridge(showMixSelectModal),
  showMixShareModal: requireBridge(showMixShareModal),
  showUserActionsModal: requireBridge(showUserActionsModal),
  showUserShareModal: requireBridge(showUserShareModal)
}
